{
  "validation": {
    "required": "Обов'язкове поле",
    "incorrectPassword": "Неправильне ім'я користувача або пароль.",
    "email": {
      "invalidFormat": "Неправильний формат"
    },
    "password": {
      "minLength": "Пароль повинен складати принаймні 8 символів"
    }
  },
  "ui": {
    "form": {
      "title": "Забули пароль?",
      "subtitle": "Введіть вашу Е-пошту, яку ви використали при реєстрації",
      "email": {
        "label": "Електронна пошта",
        "placeholder": "maill@mail.zz"
      },
      "actions": {
        "submit": {
          "label": "Підтвердити",
          "loading": "Завантаження"
        }
      }
    }
  },
  "error": "Не вдається надіслати листа. Будь ласка, спробуйте пізніше.",
  "success": "Вам надіслано лист із подальшими інструкціями."
}
